<template>
  <div>
    <div v-if="loading" style="text-align: center; padding: 40px">
      <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
    </div>
    <div v-if="isSuccess" style="padding: 100px 0; text-align: center">
      <van-icon color="#07c160" name="checked" size="50" />
      <div style="font-size: 15px; color: #666; margin-top: 16px">激活成功</div>
    </div>
    <div v-if="isFailed" style="padding: 100px 0; text-align: center">
      <van-icon color="#1592FF" name="warning" size="50" />
      <div style="font-size: 15px; color: #666; margin-top: 16px">
        {{ msg }}
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import { Toast } from "vant";
import { wxShare, dateFormat } from "@/utils";
export default {
  data() {
    return {
      loading: false,
      isFailed: false,
      isSuccess: false,
      msg: "超过48小时未激活，链接已失效，请联系老师重新获取",
    };
  },
  created() {
    this.BindFastDealFormByActiveLink();
  },
  mounted() {
    wxShare("激活线索", "【点击激活】");
  },
  methods: {
    BindFastDealFormByActiveLink() {
      const query = this.$route.query;
      if (!query.id) return;
      this.loading = true;
      const params = {
        linkId: query.id,
      };
      // if (query.accountHolderId)
      //   params.accountHolderId = query.accountHolderId
      store
        .dispatch("survey/BindFastDealFormByActiveLink", params)
        .then((data) => {
          const { Code, Data, Message } = data;
          if (Code === 0) {
            this.isSuccess = true;
            if (Data.NextIsAgreement) {
              Toast("激活成功，正跳转至签署协议!");
              setTimeout(() => {
                this.$router.replace({
                  name: "Agreement",
                  query: {
                    FormId: Data.FormId,
                    ProdId: Data.ProductId,
                    SkuId: Data.SkuId,
                  },
                });
              }, 1000);
            }
            //  else {
            //   Toast('激活成功!')
            // }
          } else {
            this.msg = Message;
            //Toast(Message || '激活失败')
            this.isFailed = true;
          }
          this.loading = false;
        })
        .catch((e) => {
          this.msg = e.Message;
          //Toast(e.Message || '激活失败')
          this.loading = false;
          this.isFailed = true;
        });
    },
  },
};
</script>
